import { IAppLocale, ILocaleTarget } from '../models/locale.model';

export const LOCALE_TARGETS: Readonly<Record<IAppLocale, ILocaleTarget>> = {
    ru: { locale: 'ru', origin: 'https://goldencalc.ru' },
    en: { locale: 'en', origin: 'https://goldencalc.com' },
};
